<atom-avatar
    class="d-none d-lg-block"
    container="body"
    display="dynamic"
    popoverClass="popover-no-padding popover-avatar"
    [class.pointer]="isAvatarInfoEnabled"
    [avatar]="avatar"
    [size]="size"
    [highlightBorder]="highlightBorder"
    [ngbPopover]="
        isAvatarInfoEnabled
            ? avatar?.isUnknown
                ? noAvatarAvailablePopover
                : avatarInfoPopover
            : null
    "
    (click)="$event.stopPropagation()"
></atom-avatar>
<atom-avatar
    class="d-block d-lg-none"
    wdxStopPropagation
    [avatar]="avatar"
    [size]="size"
    [highlightBorder]="highlightBorder"
    (click)="openAvatarModal()"
></atom-avatar>

<ng-template #avatarInfoPopover>
    @if (avatar) {
        <molecule-avatar-info
            [avatar]="avatar"
            [editModalId]="editModalId"
        ></molecule-avatar-info>
    }
</ng-template>

<ng-template #noAvatarAvailablePopover>
    <div class="p-3">
        {{ POPOVER_NO_AVATAR_AVAILABLE | translateTokenisedString }}
    </div>
</ng-template>
